export default function formatDfpId (pid) {
  if (pid.indexOf('/') === 0) {
    pid = pid.slice(1)
  }
  if (pid.lastIndexOf('/') === pid.length - 1) {
    pid = pid.slice(0, pid.length - 1)
  }
  return pid;
}
